module.exports = __webpack_public_path__ + "img/levelup-icon-confirmation-tick.d7fae4c0.svg";